export default __webpack_public_path__ + "static/media/homepageGif.79138259.gif";